import SiteHeader from "../../Components/Shared/SiteHeader";
import "./AchievementGallery.css";
import AchievementHero from "../../Components/Achivement Gallery/AchievementHero";
import GalleryEventDropdown from "../../Components/Achivement Gallery/GalleryEventDropdown";
import React, { useEffect, useRef } from "react";
import "../../Components/1st page/Header.css";
import { NavLink } from "react-router-dom";
import CampusFooter from "../../Components/Achivement Gallery/CampusFooter";
import GalleryScrollTop from "../../Components/Achivement Gallery/GalleryScrollTop";





function AchievementGalleryPage() {
  const galleryRef = useRef(null);

  useEffect(() => {
    const root = galleryRef.current;
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const registered = new Set();
    const groups = [
      ".gallery-event-copy, .gallery-event-control",
      ".gallery-event-collection > h3, .gallery-event-empty",
      ".gallery-event-media",
      ".campus-footer__content, .campus-footer__column",
      ".campus-footer__bottom",
    ];
    const observer = typeof IntersectionObserver === "undefined" ? null : new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("gallery-reveal-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: "0px 0px -20px 0px" });

    function registerElements() {
      registered.forEach((element) => {
        if (!root.contains(element)) {
          observer?.unobserve(element);
          registered.delete(element);
        }
      });
      groups.forEach((selector) => {
        root.querySelectorAll(selector).forEach((element, index) => {
          if (registered.has(element)) return;
          registered.add(element);
          element.setAttribute("data-gallery-reveal", "");
          element.style.setProperty("--gallery-reveal-delay", `${(index % 3) * 60}ms`);
          if (motion.matches || !observer) element.classList.add("gallery-reveal-visible");
          else observer.observe(element);
        });
      });
    }
    function updateMotion() {
      if (!motion.matches) return;
      registered.forEach((element) => {
        element.classList.add("gallery-reveal-visible");
        observer?.unobserve(element);
      });
    }
    registerElements();
    const mutationObserver = new MutationObserver(registerElements);
    mutationObserver.observe(root, { childList: true, subtree: true });
    motion.addEventListener("change", updateMotion);
    return () => {
      observer?.disconnect();
      mutationObserver.disconnect();
      motion.removeEventListener("change", updateMotion);
      registered.forEach((element) => {
        element.removeAttribute("data-gallery-reveal");
        element.classList.remove("gallery-reveal-visible");
        element.style.removeProperty("--gallery-reveal-delay");
      });
    };
  }, []);

  return (
    <>

      {/* Fixed Header */}
<SiteHeader animateEntrance>

            <li>
              <NavLink end to="/">Home</NavLink>
            </li>

            <li>
              <NavLink end to="/about">About Us</NavLink>
            </li>

            <li>
              <NavLink end to="/career">Career</NavLink>
            </li>

            <li>
              <NavLink end to="/gallery">Gallery</NavLink>
            </li>

            <li>

              <NavLink end to="/login">

                <button className="gallery_join_btn">
                  Join Now
                </button>

              </NavLink>

            </li>

          </SiteHeader>

      {/* Page Content */}
      <div className="achievement-gallery-page" ref={galleryRef}>

        <AchievementHero />
        <div className="gallery-page-content">
          <div className="gallery-page-floating" aria-hidden="true">
            {Array.from({ length: 8 }, (_, index) => (
              <span className={`gallery-page-glow gallery-page-glow--${index % 3}`} key={`glow-${index}`}
                style={{
                  "--glow-top": `${3 + index * 13}%`,
                  "--glow-left": `${index % 2 === 0 ? -6 : 68}%`,
                  "--glow-delay": `${index * -2}s`,
                }} />
            ))}
            {Array.from({ length: 12 }, (_, index) => (
              <span key={index} className={`gallery-page-float gallery-page-float--${index % 3}`}
                style={{
                  "--float-top": `${5 + Math.floor(index / 2) * 17}%`,
                  "--float-side": index % 2 === 0 ? "-14px" : "auto",
                  "--float-right": index % 2 === 1 ? "-14px" : "auto",
                  "--float-delay": `${index * -1.2}s`,
                }} />
            ))}
          </div>
        <GalleryEventDropdown />

        <CampusFooter/>
        </div>

      </div>
      <GalleryScrollTop />

    </>
  );
}

export default AchievementGalleryPage;

